module.exports = __webpack_public_path__ + "static/media/shipping-address-feature.751232f0.png";